import { SHOW_LOADER, MERGE_EVENTS, FETCH_EVENTS } from './constant';

const handlers = {
  [SHOW_LOADER]: state => ({ ...state, loading: true }),
  [MERGE_EVENTS]: (state, { payload }) => {
    const events = [...state.events, ...payload];
    return {
      ...state,
      events: events,
      loading: false
    };
  },
  [FETCH_EVENTS]: (state, { payload }) => ({ ...state, events: payload, loading: false }),
  DEFAULT: state => state
};

const apiReducer = (state, action) => {
  const handle = handlers[action.type] || handlers.DEFAULT;

  return handle(state, action);
};

export default apiReducer;